import { sendMarketSuiteRequest } from "@/lib/marketsuite/client";
import type { FilterBlock, PropertyFilterData, SelectedFilters } from "@/lib/types/marketsuite/datatypes/filters";
import type { MsFilterSet } from "@/payload-types";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { FILTER_TYPES_BY_SLUG } from "@/lib/marketsuite/filters/default-values";

export function useFilterData(source: MsFilterSet | FilterBlock[], selectedFilters?: SelectedFilters): PropertyFilterData | null | undefined {
	const blockTypes = useMemo(() => {
		const blocks = Array.isArray(source) ? source : (source?.filters ?? []);

		return blocks
			.filter((b) => b.settings?.dynamic)
			.map((b) => {
				const definition = FILTER_TYPES_BY_SLUG.get(b.blockType);

				return definition?.kind !== "text" && definition?.dataKey ? definition.dataKey : b.blockType;
			})
			.filter((t) => t !== null);
	}, [source]);

	const listingTypes = selectedFilters?.["listing-type"] ?? [];

	const { data } = useQuery({
		queryKey: ["filter-data", blockTypes, listingTypes],
		queryFn: () => {
			const params = new URLSearchParams();
			for (const value of blockTypes) {
				params.append("types[]", value);
			}
			for (const value of listingTypes) {
				params.append("listing-type", value);
			}

			return sendMarketSuiteRequest<PropertyFilterData>("filters/options", { params });
		},
		enabled: blockTypes.length > 0,
		refetchOnWindowFocus: false,
	});

	return data;
}
